import { useWatch } from 'react-hook-form'

import {
  type ConfigFieldContext,
  ConfigSelectField,
  ConfigTextField,
} from '../ConfigFields/ConfigFields'
import { SHEET_SELECTION_OPTIONS } from '../lib/configModalTexts'

function ConfigSheetFields({ context }: { context: ConfigFieldContext }) {
  const sheetSelectionType = useWatch({
    control: context.control,
    name: 'sheetSelectionType',
  })

  return (
    <>
      <ConfigSelectField
        context={context}
        name="sheetSelectionType"
        title="Какие листы читать"
        required
        options={SHEET_SELECTION_OPTIONS}
      />
      {sheetSelectionType === 'BY_NAME' && (
        <ConfigTextField
          context={context}
          name="sheetNames"
          title="Имена листов через запятую"
          required
        />
      )}
      {sheetSelectionType === 'BY_INDEX' && (
        <ConfigTextField
          context={context}
          name="sheetIndexes"
          title="Номера листов через запятую"
          required
          placeholder="0 = первый лист, 1 = второй"
        />
      )}
    </>
  )
}

export default ConfigSheetFields
